import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { PortalSettingsService } from '../services/portal-settings.service';
import { PortalSettings } from '../../pages/account/services/account.service';

export const anonPortalSettingsResolver: ResolveFn<PortalSettings> = () => {
  const portalSettingsService = inject(PortalSettingsService);
  return portalSettingsService.fetchAnonPortalSettings();
};
